import { defineMessages } from 'react-intl';

const messages = defineMessages({
  floorPlan: {
    id: 'App.FloorPlanDetailRow.FloorPlan',
    defaultMessage: 'Floor Plan:',
  },
  unassigned: {
    id: 'App.FloorPlanDetailRow.Unassigned',
    defaultMessage: 'Unassigned',
  },
  noPreference: {
    id: 'App.FloorPlanDetailRow.NoPreference',
    defaultMessage: 'No Preference',
  },
});

export default messages;
